<script>
    import Weekday from "./Weekday.svelte";
    
    export let periods;
    periods = periods ?? [];

    const weekdays = [
        {day: 1, name_de: "Montag"},
        {day: 2, name_de: "Dienstag"},
        {day: 3, name_de: "Mittwoch"},
        {day: 4, name_de: "Donnerstag"},
        {day: 5, name_de: "Freitag"},
        {day: 6, name_de: "Samstag"},
        {day: 7, name_de: "Sonntag"}
    ];
</script>

{#each weekdays as weekday}
    <Weekday day={weekday.day} name={weekday.name_de} bind:periods/>
{/each}